<div>
  @if (progressTracking) {
    <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor"
      [options]="progressTracking" [(update)]="updateFlag" style="width: 100%; height: 100%;">
    </highcharts-chart>
  }
</div>